import AVdxbApplicationSummaryItem from './index.vue';

AVdxbApplicationSummaryItem.install = app => {
  app.component(AVdxbApplicationSummaryItem.name, AVdxbApplicationSummaryItem);
};

export default AVdxbApplicationSummaryItem;
